__webpack_require__.p = "https://foodeon-web.dalee.ru/_next/";